module.exports = __webpack_public_path__ + "static/media/spaces-on.b7f11fe1.svg";